import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const viacep = axios.create({
  baseURL: 'https://viacep.com.br/ws/',
});

export default api;
